import * as React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { getBackend as getBackend2 } from "../lib/backend/Backend2";
import * as ta from "../lib/backend/alerts.generated.types";

import type { SelectedDatasourceObj } from "../lib/Models";

import EventTable from "./EventTable";
import Box from "./Box";
import ErrorComponent from "./ErrorComponent";

import img_alert from "../img/alert.svg";

// function that retreives additional data needed to display event
// and prepares the selected datasource object to be stored in the datasource
// state page
export async function getDatasourceDetails(datasource_uuid: string): Promise<SelectedDatasourceObj> {
    // placeholder for results
    const res: SelectedDatasourceObj = {
        datasource: null,
        analyses: [],
        recent_events_stats: null,
        events: [],
    };
    const res_events = await getBackend2().alerts.searchEvents({ datasource_uuid, limit: 10 });
    res.events = res_events.data;
    const res_events2 = await getBackend2().alerts.getStats({ datasource_uuid, n_hours: 24 });
    const res_ds = await getBackend2().datasources.getDatasourceDetails({ id: datasource_uuid });
    res.datasource = res_ds.data;
    res.recent_events_stats = res_events2;
    res.analyses = res_ds.analyses;
    return res;
}

type Props = {
    selected: SelectedDatasourceObj;
    error: string | null;
};

// Prepares a list of events to be displayed on event page as a scrollable side bar on the le
class DatasourceDetails extends React.Component<Props> {
    // render main event and datapoint indicators
    renderIndicators(recent_event_stats: ta.IGetStatsRes) {
        return (
            <div className="row">
                <div className="col-lg-6 col-md-6">
                    <Box
                        value={recent_event_stats.alerts_data_24h}
                        label={"Incidents detected (<24h)"}
                        icon={img_alert}
                        color="#ff352b"
                        sparkline={recent_event_stats.alerts_data_24h_by_hour.map(x => x.val)}
                    />
                </div>
            </div>
        );
    }

    // render extra data associated with the current selected datasource type
    renderExtraData(selected: SelectedDatasourceObj) {
        const render_divs: React.ReactNode[] = [];
        // show input data
        const datasource = selected.datasource;
        if (!datasource) {
            return null;
        }
        const analyses = selected.analyses;

        if (analyses) {
            for (const an of analyses) {
                render_divs.push(
                    <div className="light" key={"analysis-uuid-" + an.uuid}>
                        Analysis uuid: {an.uuid}
                    </div>
                );
            }
        }
        return render_divs;
    }

    renderEvents(events: any) {
        return (
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <hr />
                    <h3 className="table_header">
                        <FormattedMessage id="Header.menu.events" defaultMessage="Events" />
                    </h3>
                    <EventTable events={events} />
                    <Link className="blue_link" to="/admin/events">
                        More &#187;
                    </Link>
                </div>
            </div>
        );
    }

    // prepare list of events
    render() {
        if (this.props.selected && this.props.selected.datasource) {
            const selected = this.props.selected;
            const datasource = this.props.selected.datasource;
            return (
                <div className="tab-content" key={datasource.uuid}>
                    <div className="tab-pane active" id="home">
                        <ErrorComponent msg={this.props.error} type="error" />
                        <div className="row">
                            <div className="col-12">
                                <div className="active_data">
                                    <h5>{datasource.title}</h5>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="white_box charts">
                                    <p className="data_source_text">
                                        <span>Code:</span> {datasource.code}{" "}
                                    </p>
                                    <p className="data_source_text light">
                                        <span>UUID:</span> {datasource.uuid}{" "}
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="white_box charts">
                                    <p className="data_source_text">
                                        <span>Type:</span> {datasource.type}{" "}
                                    </p>
                                    <p className="data_source_text">
                                        <span>Status:</span> {datasource.active ? "Active" : "Inactive"}{" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                        {selected.recent_events_stats && this.renderIndicators(selected.recent_events_stats)}
                        {this.renderExtraData(selected)}
                        {this.renderEvents(selected.events)}
                    </div>
                </div>
            );
        }
        return <div />;
    }
}

export default DatasourceDetails;
